<template>
  <v-container fluid pa-0>
    <v-card tile flat>
      <v-card-title>
        <v-text-field
          rounded
          filled
          prepend-inner-icon="mdi-magnify"
          label="Sök..."
          v-model="search"
          dense
          :hide-details="true"
          class="mr-4"
        ></v-text-field>
        <v-menu
          v-model="menu"
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              rounded
              filled
              label="Avgångsdatum"
              :value="formattedDate"
              dense
              :hide-details="true"
              v-on="on"
              v-bind="attrs"
              readonly
              prepend-inner-icon="mdi-calendar-range"
              class="mr-4"
            />
          </template>
          <v-date-picker
            first-day-of-week="1"
            v-model="selectedDateRange"
            range
          />
        </v-menu>
        <v-btn
          @click="fetchData()"
          large
          rounded
          color="primary"
          :loading="pending"
        >
          <v-icon small left>mdi-magnify</v-icon>
          Sök
        </v-btn>
        <v-spacer />
      </v-card-title>
      <v-data-table
        :loading="pending"
        :headers="headers"
        :items="tableData"
        :search="search"
        :sort-by="sortBy"
        :sort-desc="true"
        fixed-header
        :height="tableHeight"
        :options="{
          itemsPerPage: 50
        }"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, -1]
        }"
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { format } from 'date-fns'
import inputTableHeight from '../../../mixins/inputTableHeight'
import gql from 'graphql-tag'

export default {
  name: 'SmsLogTable',

  created() {
    this.fetchData()
  },

  data() {
    return {
      sortBy: 'created',
      pending: false,
      selectedDate: format(new Date(), 'yyyy-MM-dd'),
      menu: false,
      selectedDateRange: [
        format(new Date(), 'yyyy-MM-dd'),
        format(new Date(), 'yyyy-MM-dd')
      ],
      search: '',
      smsLogs: [],
      deliveryStatus: [
        {
          text: 'Skickat',
          value: 'sent'
        },
        {
          text: 'Ej skickat',
          value: 'notsent'
        },
        {
          text: 'Skapad',
          value: 'created'
        },
        {
          text: 'Levererat',
          value: 'delivered'
        },
        {
          text: 'Misslyckat',
          value: 'failed'
        }
      ],
      headers: [
        {
          text: 'Biljett-ID',
          value: 'ticket_id',
          width: 150
        },
        {
          text: 'Från',
          value: 'from',
          width: 75
        },
        {
          text: 'Till',
          value: 'to',
          width: 75
        },
        {
          text: 'Avgång',
          value: 'time_start',
          width: 150
        },
        {
          text: 'Ankomst',
          value: 'time_end',
          width: 150
        },
        {
          text: 'Status',
          value: 'status',
          width: 120
        },
        {
          text: 'Meddelande',
          value: 'message'
        }
      ]
    }
  },

  mixins: [inputTableHeight(144)],

  computed: {
    tableData() {
      return (this.smsLogs || []).map(x => ({
        ...x,
        status: this.deliveryStatus.find(y => y.value === x.status).text
      }))
    },
    formattedDate() {
      const [start, end] = this.selectedDateRange || []
      if (start && end) return `${start} - ${end}`
      return start || ''
    }
  },

  methods: {
    async fetchData() {
      this.pending = true
      const {
        data: { sms_logs }
      } = await this.$apollo.query({
        query: gql`
          query GetSmsLogs($filter: GetSmsLogs!) {
            sms_logs(filter: $filter) {
              order_id
              sales_order_id
              ticket_id
              traveller_firstname
              traveller_lastname
              status
              sent_at
              delivered_at
              departure_date
              time_start
              time_end
              from
              to
              train_number
              message
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            fromDate: this.selectedDateRange.at(0),
            toDate: this.selectedDateRange.at(1)
          }
        }
      })
      this.smsLogs = sms_logs
      this.pending = false
    }
  }
}
</script>
